"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEndpointClaimsRecord = void 0;
function generateEndpointClaimsRecord(address) {
    return `/evmos/claims/v1/claims_records/${address}`;
}
exports.generateEndpointClaimsRecord = generateEndpointClaimsRecord;
//# sourceMappingURL=claims.js.map